<div class="container mt-2 gx-5 gy-5">
    <div class="row gx-5">
        <div *ngFor="let tile of tiles" class="card border-primary p-3 mb-2 col-sm-12 col-md" style="margin-left: 5px; margin-right: 5px;">
            <div class="d-flex align-items-center">
                <div class="avatar border-primary rounded no-thumbnail bg-primary"><i  style="color: white;" class="{{tile.icon}}"></i></div>
                <div class="flex-fill ms-3 text-truncate">
                    <div class="small">{{tile.title}}</div>
                    <span *ngIf="tile.isAmount" class="h6 mb-0">${{tile.value | currency:'CLP':'':'1.0-0'}}</span>
                    <span *ngIf="!tile.isAmount" class="h6 mb-0">{{tile.value}}</span>
                </div>
            </div>
        </div>
    </div>
</div>
